import { IDataEndPoint, IEntityEndPoints, IFieldOptions, IFormOptions, IGridOptions, IColumnOptions, IEntityOptions } from '@framework/interfaces/IEntity';
import * as app from '@framework/app';
import * as models from '@common/domain/models/RequisitionItemDTO';
import { IApiServiceCommand } from '@services/api/api.service';
export class RequisitionItemEndPoints implements IEntityEndPoints {
	list?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionItem"}, method: "GET" };
	get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionItem/" + serviceCommand.context.entityId}, method: "GET" };
	update?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionItem/update/" + serviceCommand.context.entityId}, method: "POST" };
	search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionItem/lazy/"}, method: "POST" };
	pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionItem/lazyCount/"}, method: "POST" };
	insert?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionItem/create"}, method: "POST" };
	delete?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionItem/delete/"+ serviceCommand.context.entityId}, method: "POST" };
}


export class RequisitionItemFormFields extends Array<IFieldOptions> {
	public id: IFieldOptions = { field: "id" };
	public status: IFieldOptions = { field: "status" };
	public datestamp: IFieldOptions = { field: "datestamp" };
	public changedById: IFieldOptions = { field: "changedById" };
	public requisitionId: IFieldOptions = { field: "requisitionId" };
	public jobId: IFieldOptions = { field: "jobId" };
	public taxCodeId: IFieldOptions = { field: "taxCodeId" };
	public requisitionPartialId: IFieldOptions = { field: "requisitionPartialId" };
	public dueDate: IFieldOptions = { field: "dueDate" };
	public qty: IFieldOptions = { field: "qty" };
	public procurementOfficeUserId: IFieldOptions = { field: "procurementOfficeUserId" };
	public buyerUserId: IFieldOptions = { field: "buyerUserId" };
	public latestRequisitionItemWorkflowId: IFieldOptions = { field: "latestRequisitionItemWorkflowId" };
	public stockItemSupplierId: IFieldOptions = { field: "stockItemSupplierId" };
	public inStock: IFieldOptions = { field: "inStock" };
	public sivNumber: IFieldOptions = { field: "sivNumber" };
	public generalLedgerId: IFieldOptions = { field: "generalLedgerId" };
	public hierarchyId: IFieldOptions = { field: "hierarchyId" };
	public price: IFieldOptions = { field: "price" };
	public isStandardItem: IFieldOptions = { field: "isStandardItem" };
	public taxable: IFieldOptions = { field: "taxable" };
	public nonStandardItemDescription: IFieldOptions = { field: "nonStandardItemDescription" };
	public approvalRequested: IFieldOptions = { field: "approvalRequested" };
	public approvalGranted: IFieldOptions = { field: "approvalGranted" };
	public supplierId: IFieldOptions = { field: "supplierId" };
	public approvalRejected: IFieldOptions = { field: "approvalRejected" };
	public stockItemId: IFieldOptions = { field: "stockItemId" };
	public jobSpecific: IFieldOptions = { field: "jobSpecific" };
	public projectJobNumberId: IFieldOptions = { field: "projectJobNumberId" };
	public standardItemSupplierNotLinked: IFieldOptions = { field: "standardItemSupplierNotLinked" };
	public unitPrice: IFieldOptions = { field: "unitPrice" };
	public sisProLineNum: IFieldOptions = { field: "sisProLineNum" };
	public sysproError: IFieldOptions = { field: "sysproError" };
	public sysproImportedFlag: IFieldOptions = { field: "sysproImportedFlag" };
	public sysproPo: IFieldOptions = { field: "sysproPo" };
	public sysproReceivedQty: IFieldOptions = { field: "sysproReceivedQty" };
	public sysproOrderCompleted: IFieldOptions = { field: "sysproOrderCompleted" };
  public sysproTimestamp: IFieldOptions = { field: "sysproTimestamp" };
  public warehouseId: IFieldOptions = { field: "warehouseId" };
  public variant: IFieldOptions = { field: "variant" };
  public invoiceNo: IFieldOptions = { field: "invoiceNo" };
  public sivRequired: IFieldOptions = { field: "sivRequired" };
  public uom: IFieldOptions = { field: "uom" };
  public discountPrice: IFieldOptions = { field: "discountPrice" };
  
	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.requisitionId);
		this.push(this.jobId);
		this.push(this.taxCodeId);
		this.push(this.requisitionPartialId);
		this.push(this.dueDate);
		this.push(this.qty);
		this.push(this.procurementOfficeUserId);
		this.push(this.buyerUserId);
		this.push(this.latestRequisitionItemWorkflowId);
		this.push(this.stockItemSupplierId);
		this.push(this.inStock);
		this.push(this.sivNumber);
		this.push(this.generalLedgerId);
		this.push(this.hierarchyId);
		this.push(this.price);
		this.push(this.isStandardItem);
		this.push(this.taxable);
		this.push(this.nonStandardItemDescription);
		this.push(this.approvalRequested);
		this.push(this.approvalGranted);
		this.push(this.supplierId);
		this.push(this.approvalRejected);
		this.push(this.stockItemId);
		this.push(this.jobSpecific);
		this.push(this.projectJobNumberId);
		this.push(this.standardItemSupplierNotLinked);
		this.push(this.unitPrice);
		this.push(this.sisProLineNum);
		this.push(this.sysproError);
		this.push(this.sysproImportedFlag);
		this.push(this.sysproPo);
		this.push(this.sysproReceivedQty);
		this.push(this.sysproOrderCompleted);
      this.push(this.sysproTimestamp);
      this.push(this.warehouseId);
    this.push(this.variant);
    this.push(this.invoiceNo);
    this.push(this.sivRequired)
	}
}

export class RequisitionItemForm implements IFormOptions {
	protected requisitionItemFormName: string = "requisitionItemForm";
	protected requisitionItemFormModel: models.RequisitionItemDTO = new models.RequisitionItemDTO();
	protected requisitionItemFormEndPoints: RequisitionItemEndPoints = new RequisitionItemEndPoints();
	protected requisitionItemFormFields: RequisitionItemFormFields = new RequisitionItemFormFields();
	public get name(): string { return this.requisitionItemFormName };
	public get model(): models.RequisitionItemDTO { return this.requisitionItemFormModel };
	public get endPoints(): IEntityEndPoints { return this.requisitionItemFormEndPoints };
       public set endPoints(requisitionItemEndPoints: IEntityEndPoints) {
		this.requisitionItemFormEndPoints = requisitionItemEndPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.get };
	public get fields(): RequisitionItemFormFields { return this.requisitionItemFormFields };
}

export class RequisitionItemListColumns extends Array<IColumnOptions> {
	public id: IColumnOptions = { field: "id" };
	public status: IColumnOptions = { field: "status" };
	public datestamp: IColumnOptions = { field: "datestamp", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public changedById: IColumnOptions = { field: "changedById" };
	public requisitionId: IColumnOptions = { field: "requisitionId" };
	public jobId: IColumnOptions = { field: "jobId" };
	public taxCodeId: IColumnOptions = { field: "taxCodeId" };
	public requisitionPartialId: IColumnOptions = { field: "requisitionPartialId" };
	public dueDate: IColumnOptions = { field: "dueDate", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public qty: IColumnOptions = { field: "qty" };
	public procurementOfficeUserId: IColumnOptions = { field: "procurementOfficeUserId" };
	public buyerUserId: IColumnOptions = { field: "buyerUserId" };
	public latestRequisitionItemWorkflowId: IColumnOptions = { field: "latestRequisitionItemWorkflowId" };
	public stockItemSupplierId: IColumnOptions = { field: "stockItemSupplierId" };
	public inStock: IColumnOptions = { field: "inStock" };
	public sivNumber: IColumnOptions = { field: "sivNumber" };
	public generalLedgerId: IColumnOptions = { field: "generalLedgerId" };
	public hierarchyId: IColumnOptions = { field: "hierarchyId" };
	public price: IColumnOptions = { field: "price" };
	public isStandardItem: IColumnOptions = { field: "isStandardItem" };
	public taxable: IColumnOptions = { field: "taxable" };
	public nonStandardItemDescription: IColumnOptions = { field: "nonStandardItemDescription" };
	public approvalRequested: IColumnOptions = { field: "approvalRequested" };
	public approvalGranted: IColumnOptions = { field: "approvalGranted" };
	public supplierId: IColumnOptions = { field: "supplierId" };
	public approvalRejected: IColumnOptions = { field: "approvalRejected" };
	public stockItemId: IColumnOptions = { field: "stockItemId" };
	public jobSpecific: IColumnOptions = { field: "jobSpecific" };
	public projectJobNumberId: IColumnOptions = { field: "projectJobNumberId" };
	public standardItemSupplierNotLinked: IColumnOptions = { field: "standardItemSupplierNotLinked" };
	public unitPrice: IColumnOptions = { field: "unitPrice" };
	public sisProLineNum: IColumnOptions = { field: "sisProLineNum" };
	public sysproError: IColumnOptions = { field: "sysproError" };
	public sysproImportedFlag: IColumnOptions = { field: "sysproImportedFlag" };
	public sysproPo: IColumnOptions = { field: "sysproPo" };
	public sysproReceivedQty: IColumnOptions = { field: "sysproReceivedQty" };
	public sysproOrderCompleted: IColumnOptions = { field: "sysproOrderCompleted" };
  public sysproTimestamp: IColumnOptions = { field: "sysproTimestamp" };
  public warehouseId: IFieldOptions = { field: "warehouseId" };
  public variant: IFieldOptions = { field: "variant" };
  public sivRequired: IColumnOptions = { field: "sivRequired" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.requisitionId);
		this.push(this.jobId);
		this.push(this.taxCodeId);
		this.push(this.requisitionPartialId);
		this.push(this.dueDate);
		this.push(this.qty);
		this.push(this.procurementOfficeUserId);
		this.push(this.buyerUserId);
		this.push(this.latestRequisitionItemWorkflowId);
		this.push(this.stockItemSupplierId);
		this.push(this.inStock);
		this.push(this.sivNumber);
		this.push(this.generalLedgerId);
		this.push(this.hierarchyId);
		this.push(this.price);
		this.push(this.isStandardItem);
		this.push(this.taxable);
		this.push(this.nonStandardItemDescription);
		this.push(this.approvalRequested);
		this.push(this.approvalGranted);
		this.push(this.supplierId);
		this.push(this.approvalRejected);
		this.push(this.stockItemId);
		this.push(this.jobSpecific);
		this.push(this.projectJobNumberId);
		this.push(this.standardItemSupplierNotLinked);
		this.push(this.unitPrice);
		this.push(this.sisProLineNum);
		this.push(this.sysproError);
		this.push(this.sysproImportedFlag);
		this.push(this.sysproPo);
		this.push(this.sysproReceivedQty);
		this.push(this.sysproOrderCompleted);
      this.push(this.sysproTimestamp);
      this.push(this.warehouseId);
    this.push(this.variant);
    this.push(this.sivRequired);
	}
}

export class RequisitionItemList implements IGridOptions {
	protected requisitionItemListName: string = "requisitionItemList";
	protected requisitionItemListModel: models.RequisitionItemDTO = new models.RequisitionItemDTO();
	protected requisitionItemListEndPoints: RequisitionItemEndPoints = new RequisitionItemEndPoints();
	protected requisitionItemListColumns: RequisitionItemListColumns = new RequisitionItemListColumns();
	public requisitionItemForm: RequisitionItemForm = new RequisitionItemForm();
	public get name(): string { return this.requisitionItemListName };
	public get model(): models.RequisitionItemDTO { return this.requisitionItemListModel };
	public get endPoints(): IEntityEndPoints { return this.requisitionItemListEndPoints };
	public set endPoints(requisitionItemEndPoints: IEntityEndPoints) {
		this.requisitionItemListEndPoints = requisitionItemEndPoints;
		this.requisitionItemForm.endPoints = this.endPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
	public get columns(): RequisitionItemListColumns { return this.requisitionItemListColumns };
}

export class RequisitionItemEntity implements IEntityOptions {
	protected requisitionItemEntityName: string = "requisitionItemEntity";
	protected requisitionItemEntityModel: models.RequisitionItemDTO = new models.RequisitionItemDTO();
	protected requisitionItemEntityEndPoints: RequisitionItemEndPoints = new RequisitionItemEndPoints();
	protected requisitionItemEntityList: RequisitionItemList = new RequisitionItemList();
	public get name(): string { return this.requisitionItemEntityName };
	public get model(): models.RequisitionItemDTO { return this.requisitionItemEntityModel };
	public get endPoints(): IEntityEndPoints { return this.requisitionItemEntityEndPoints };
	public set endPoints(requisitionItemEndPoints: IEntityEndPoints) {
		this.requisitionItemEntityEndPoints = requisitionItemEndPoints;
		this.grid.endPoints = this.endPoints;
	};
	public get grid(): RequisitionItemList { return this.requisitionItemEntityList };
	public get form(): RequisitionItemForm { return this.grid.requisitionItemForm };
	constructor(name?: string) {
		if (name) this.requisitionItemEntityName = name;
		this.endPoints = this.requisitionItemEntityEndPoints;
	}
};
//export class RequisitionItemGeneratedForm extends MfGeneratedFormComponent {
 // protected detailPageComponentForm: RequisitionItemForm = new RequisitionItemForm();
//};

//export class RequisitionItemListPageComponent extends ListPageComponent {
  //protected listPageComponentList: RequisitionItemList = new  RequisitionItemList();
  //protected showFilterColOnTable: boolean = true;
//};

//export class RequisitionItemBlade extends MfBladeComponent {
  //protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: RequisitionItemGeneratedForm}];
//};

//export class RequisitionItemListBlade extends MfBladeComponent {
 // protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: RequisitionItemListPageComponent, isMenuHidden: true }];
//};

